namespace GeniuzPOS.RefundReasonReport {
    export interface ReportRefundReasonByBillForm {
        DocDate: Serenity.DateEditor;
        DocTime: Serenity.DateEditor;
        DocNo: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        ShopName: Serenity.StringEditor;
        CashierId: Serenity.StringEditor;
        CashierName: Serenity.StringEditor;
        AppRefund: Serenity.StringEditor;
        RefundId: Serenity.IntegerEditor;
        RefundReason: Serenity.StringEditor;
        PosId: Serenity.StringEditor;
        SalesmanId: Serenity.StringEditor;
        SalesmanName: Serenity.StringEditor;
        MbId: Serenity.StringEditor;
        MbNameT: Serenity.StringEditor;
        GrossSales: Serenity.DecimalEditor;
        AllItemDiscount: Serenity.DecimalEditor;
        NetSales: Serenity.DecimalEditor;
        NetSalesExVat: Serenity.DecimalEditor;
        VatOfNetSales: Serenity.DecimalEditor;
        VatOfCharge: Serenity.DecimalEditor;
        BillCharge: Serenity.DecimalEditor;
    }

    export class ReportRefundReasonByBillForm extends Serenity.PrefixedContext {
        static formKey = 'RefundReasonReport.ReportRefundReasonByBill';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportRefundReasonByBillForm.init)  {
                ReportRefundReasonByBillForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ReportRefundReasonByBillForm, [
                    'DocDate', w0,
                    'DocTime', w0,
                    'DocNo', w1,
                    'ShopId', w1,
                    'ShopName', w1,
                    'CashierId', w1,
                    'CashierName', w1,
                    'AppRefund', w1,
                    'RefundId', w2,
                    'RefundReason', w1,
                    'PosId', w1,
                    'SalesmanId', w1,
                    'SalesmanName', w1,
                    'MbId', w1,
                    'MbNameT', w1,
                    'GrossSales', w3,
                    'AllItemDiscount', w3,
                    'NetSales', w3,
                    'NetSalesExVat', w3,
                    'VatOfNetSales', w3,
                    'VatOfCharge', w3,
                    'BillCharge', w3
                ]);
            }
        }
    }
}
